var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-select', _vm._g(_vm._b({ model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, 'el-select', _vm.innerConfig.params, false), _vm.$listeners), _vm._l(_vm.languageList, function (opt) {
    return _c('el-option', { key: opt.value, attrs: { "label": opt.label, "value": opt.value, "disabled": opt.disabled } });
  }), 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };